/**
 * Placeholder for the social cookie embeds
 *
 * type: 'social', 'miscellaneous', 'recommandation', 'advertising', 'default'
 * remove: use when you want to remove the element of the data attr
 *
 * Usage: data-at-ccm-placeholder='{"type":"social", "remove":true}'
 */
class Placeholder {
    /**
     *
     * @param $element
     * @param options
     */
    constructor ($element, options) {
        this.$element = $element;
        this.type = options.type || 'default';
        this.remove = options.remove !== undefined ? options.remove : true;

        this.isDissallowed();
    }

    /**
     * @returns two {functions}
     * insert a template in the DOM and remove the element if this.remove is true
     */
    isDissallowed () {
        At.Util.Cookie.ccmQueue.callOnDisallow(this.type, () => {
            return this.insertTemplate() && this.removeElement();
        });
    }

    /**
     *
     * @returns {string}
     */
    template () {
        const template = `
            <div class="cookie-placeholder">
                <h3 class="cookie-placeholder-header">Je hebt onze ${Placeholder.template[this.type].heading} cookies (nog) niet geaccepteerd.</h3>
                <p class="cookie-placeholder-content">${Placeholder.template[this.type].content}</p>
                <button class="cookie-placeholder-button" onclick="At.Util.ShowCC();" data-ccm-placeholder-type="${this.type}">Wijzig cookie-instellingen</button>
            </div>`;

        return template;
    }

    removeElement () {
        if (!this.remove) {
            return false;
        }

        // remove the element of the data-attr is remove is true
        return this.$element.remove();
    }

    insertTemplate () {
        // insert the template after the element with the data-attr
        return this.$element.after(this.template());
    }

    /**
     * Attach new toggle
     * @private
     */
    _attach () {
        const $el = $(this),
            options = $el.data('at-ccm-placeholder');

        new Placeholder($el, options);
    }
}

Placeholder.template = {
    'social': {
        'heading': 'social media',
        'content': 'Oh oh... Deze content kun je niet delen of niet zien omdat je de social cookies (nog) niet hebt geaccepteerd. Alles zien en delen? Wijzig dan je cookie-instellingen.'
    },
    'miscellaneous': {
        'heading': 'overige',
        'content': 'Doet dit onderdeel van deze website het niet? Voor een volledig werkende website accepteer je hier de Overige cookies.'
    },
    'recommandation': {
        'heading': 'aanbevelings',
        'content': 'Graag laten we jou in aanraking komen met informatie en programma\'s die je interresant vindt. Benieuwd naar onze aanbevelingen, wijzig dan je cookie-instellingen.'
    },
    'advertising': {
        'heading': 'advertentie',
        'content': 'Huh..maar ik zie nog steeds STER advertenties? Dat klopt! Op basis van de advertentiecookie kunnen deze reclames relevanter worden gemaakt, dus wil je relevantere advertenties, wijzig je cookies hier.'
    },
    'default': {
        'heading': '',
        'content': 'Wil je deze inhoud zien, vink dan alle cookies aan in de cookie-instellingen'
    }
};

export default Placeholder;
